import { metis } from '@0xtorch/core'
import { metis as viemMetis } from 'viem/chains'
import { type Client, createClient } from '../../client'
import { type Explorer, createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createMetisChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}) =>
  createMetisChainCustom({
    client: createClient({
      chain: viemMetis,
      httpRpcs: metisHttpRpcs,
    }),
    explorer: createBlockscout({
      name: 'Metis Andromeda explorer',
      baseUrl: 'https://andromeda-explorer.metis.io',
      apiBaseUrl: 'https://andromeda-explorer.metis.io/api',
      proxyUrl,
    }),
  })

type CreateMetisChainParameters = {
  client: Client
  explorer: Explorer
}

export const createMetisChainCustom = ({
  client,
  explorer,
}: CreateMetisChainParameters): Chain => ({
  id: 1088,
  network: 'metis',
  name: 'Metis',
  nativeToken: {
    name: 'Metis',
    symbol: 'METIS',
    decimals: 18,
    currency: metis,
  },
  wrappedTokenAddresses: new Set([
    '0x75cb093e4d61d2a2e65d8e0bbb01de8d89b53481',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'metis-andromeda',
  defillamaId: 'metis',
})

export const metisHttpRpcs: HttpRpc[] = [
  {
    url: 'https://andromeda.metis.io/?owner=1088',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 160_000n,
  },
  {
    url: 'https://metis.api.onfinality.io/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
  {
    url: 'https://metis-pokt.nodies.app',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 80_000n,
  },
  {
    url: 'https://metis.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const metisWebsocketRpcUrls: readonly string[] = [
  'wss://andromeda-ws.metis.io',
  'wss://metis.drpc.org',
]
